'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var label = {
  color: 'gray.400',
  opacity: 1,
  transitionProperty: 'common',
  transitionDuration: 'normal',
  _disabled: {
    opacity: 0.4
  }
};
exports["default"] = label;